import React, { Dispatch, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, createTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import XLSX from 'xlsx'
import Button from '@material-ui/core/Button';
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import FullscreenLoader from '../../common/components/FullscreenLoader';
import moment from "moment-timezone";
import NotificationIcon from '../../common/components/NotificationIcon';
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import _, { get } from "lodash";
import { useHistory, useLocation } from "react-router-dom";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import GetAppIcon from '@material-ui/icons/GetApp';
import ReturnRequestPopup from './ReturnRequestPopup';
import ReturnAllRequestPopup from './ReturnAllRequestPopup';
import AnnouncementIcon from "../../common/components/AnnouncementIcon";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    actionButtons: {
        display: 'flex',
        gap: 16,
        marginTop: 24,
        marginBottom: 24,
    },
    actionButton: {
        color: '#1A9FE0',
    },
    headerSection: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 24,
    },
    pageTitle: {
        fontSize: '1.75rem',
        fontWeight: 700,
        fontFamily: 'Nunito',
        color: '#1a1a1a',
        margin: 0,
    },
    iconGroup: {
        marginLeft: 'auto',
        display: 'flex',
        gap: 16,
        alignItems: 'center',
    },
    invoiceHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 14,
    },
    invoiceInfo: {
        display: 'flex',
        flexDirection: 'row',
        gap: 10,
    },
    invoiceId: {
        fontSize: '1.125rem',
        fontWeight: 700,
        fontFamily: 'Nunito',
        color: '#1a1a1a',
        margin: 0,
    },
    invoiceDate: {
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        color: '#140c0cff',
        margin: 0,
        fontWeight: 600,
        paddingTop: 6
    },
    headerActions: {
        display: 'flex',
        gap: 16,
        alignItems: 'center',
    },
    backButton: {
        color: '#1A9FE0',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 600,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    exportButton: {
        backgroundColor: 'transparent',
        color: '#1A9FE0',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 600,
        textTransform: 'none',
        padding: '6px 16px',
        borderRadius: 4,
        '&:hover': {
            backgroundColor: '#f0f9ff',
        },
    },
    grossValue: {
        fontSize: '1rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        color: '#1a1a1a',
        margin: 0,
    },
    tableContainer: {
        backgroundColor: '#ffffff',
        borderRadius: 8,
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    },
    tableHeader: {
        backgroundColor: '#ffffff',
    },
    headerCell: {
        color: '#133F8A',
        fontWeight: 900,
        fontSize: '0.75rem',
        textAlign: 'center',
        fontFamily: 'Nunito',
        borderBottom: '2px solid #e0e0e0',
        padding: '16px',
        whiteSpace: 'nowrap',
    },
    headerCell1: {
        color: '#133F8A',
        fontWeight: 900,
        textAlign: 'center',
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
        backgroundColor: '#f2f2f2',
        borderBottom: '2px solid #e0e0e0',
        padding: '16px',
        whiteSpace: 'nowrap',
    },
    subHeaderText: {
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
        fontWeight: 600,
        color: '#161212ff',
        marginTop: 4,
    },
    subHeaderText1: {
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
        fontWeight: 600,
        color: '#161212ff',
        marginTop: 4,
    },
    bodyCell: {
        color: '#666666',
        fontWeight: 600,
        fontSize: 12,
        textAlign: 'center',
        fontFamily: 'Nunito',
        borderBottom: '1px solid #f0f0f0',
        padding: '16px',
    },
    bodyCell2: {
        fontWeight: 600,
        fontSize: 12,
        textAlign: 'center',
        fontFamily: 'Nunito',
        borderBottom: '1px solid #f0f0f0',
        padding: '16px',
    },
    submittedBodyCell: {
        color: '#5d0996ff',
        fontWeight: 600,
        fontSize: 12,
        textAlign: 'center',
        fontFamily: 'Nunito',
        borderBottom: '1px solid #f0f0f0',
        padding: '16px',
    },
    bodyCell1: {
        color: '#666666',
        fontWeight: 600,
        fontSize: 12,
        fontFamily: 'Nunito',
        borderBottom: '1px solid #f0f0f0',
        padding: '16px',
        backgroundColor: '#f2f2f2',
        textAlign: 'center'
    },
    cancelButton: {
        backgroundColor: 'transparent',
        color: '#D32F2F',
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
        fontWeight: 600,
        textTransform: 'none',
        padding: '6px 10px',
        borderRadius: 16,
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        cursor: 'pointer',
    },
    buttonSection: {
        display: 'flex',
        alignItems: "center",
        justifyContent: 'space-between',
    },
    actionButtons1: {
        display: 'flex',
        gap: 16,
    },
    paginationContainer: {
        borderTop: '1px solid #e0e0e0',
    },
    returnRequestedRow: {
        backgroundColor: 'white !important',
    },
}));

export default function ViewReturnOrder() {
    const classes = useStyles();
    const history = useHistory()
    const [page, setPage] = React.useState(0);
    const rowsPerPage = 10;
    const dispatch: Dispatch<any> = useDispatch();
    const [successMessage, setSuccessMessage] = React.useState<any>(null);
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [loading, setLoading] = React.useState<any>(false);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [showErrorMessage, setShowErrorMessage] = React.useState<any>(null);
    const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
    const userName = get(profileDetails, 'data.data.basicInfo.displayName', "");
    const [showReturnRequestPopup, setShowReturnRequestPopup] = React.useState<boolean>(false);
    const [showAllReturnRequestPopup, setShowAllReturnRequestPopup] = React.useState<boolean>(false);
    const { viewDelivery, billingDetails, deleteReturnRequestDetails, getReturnOrderDetails, viewReturnOrderAPIDetails }: any = useSelector((state: any) => state.delivery);
    const webApplicationLoginId: any = sessionStorage.getItem("webApplicationLoginId");
    const InoviceDate = sessionStorage.getItem("reorder-InoviceDate");
    const isFSE = sessionStorage.getItem('userType') === 'FSE';
    const [returnRequests, setReturnRequests] = React.useState<any>({});
    const [selectedReturnItem, setSelectedReturnItem] = React.useState<any>(null);
    const [etag, setEtag] = React.useState<any>("");

    // Get invoice data from billingDetails
    const invoiceData = billingDetails?.data?.data || null;
    const invoiceId = invoiceData?.data?.invoiceId;
    const returnOrderData = viewReturnOrderAPIDetails?.data?.data || null;

    useEffect(() => {
        if (invoiceId) {
            const savedData = sessionStorage.getItem(`returnRequests_${invoiceId}`);
            if (savedData) {
                try {
                    const parsedData = JSON.parse(savedData);
                    setReturnRequests(parsedData);
                } catch (error) {
                    console.error('Error loading auto-saved data:', error);
                }
            }
        }
    }, [invoiceId]);

    useEffect(() => {
        if (invoiceId && Object.keys(returnRequests).length > 0) {
            sessionStorage.setItem(`returnRequests_${invoiceId}`, JSON.stringify(returnRequests));
        }
    }, [returnRequests, invoiceId]);

    const exportInvoice = () => {
        const dataSource = returnOrderData?.data || invoiceData?.data?.itemDetails;

        if (dataSource && dataSource.length > 0) {
            let filename = `Invoice - ${returnOrderData?.invoiceNumber || 'ReturnOrder'}.xlsx`;
            let data: any = [];

            dataSource.forEach((item: any, index: number) => {
                data.push({
                    'SN': index + 1,
                    'Part No.': item.materialNumber || '-',
                    'Description': item.description || '-',
                    'Delivered Qty': item.deliveredQty || 0,
                    'Returned Qty': item.returnedQty || 0,
                    'Return Reason': item.reason || '-',
                    'Unit Price (Excl. VAT)': item.netPrice ? Number(item.netPrice.toFixed(2)) : 0,
                    'Net Value (Excl. VAT)': item.netValue ? Number(item.netValue.toFixed(2)) : 0,
                    'Return Qty - Requested': item.returnQty || 0,
                    'Return Qty - Approved': item.approvedQty || 0,
                    'Return Net Value (Excl. VAT)': item.returnNetValue ? Number(item.returnNetValue.toFixed(2)) : 0,
                    'Status': item.status || '-'
                });
                return undefined;
            });

            var ws = XLSX.utils.json_to_sheet(data);

            // Column widths
            const headers = Object.keys(data[0]);
            ws['!cols'] = headers.map((key) => {
                const maxLen = Math.max(
                    key.length,
                    ...data.map((row: any) => String(row[key] ?? '').length)
                );
                return { wch: maxLen + 6 };
            });

            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "sheet1");
            XLSX.writeFile(wb, filename);
        }
    };

    const handleopenCloseSnackbar = (open?: any) => {
        setOpenSnackbar(open ? true : false);
    };

    const handleopenCloseErrorSnackbar = (open?: any) => {
        setOpenErrorSnackbar(open ? true : false);
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };
    const getStatusColor = (status: string): string => {
        switch (status) {
            case "Quality check pending":
                return "#0F336E";
            case "Approved":
                return "#30BD4C";
            case "Not Approved":
                return "#FF0000";
            case "In Progress":
                return "#1A9FE0";
            case "Partially Approved":
                return "#E88B00";
            default:
                return "black";
        }
    };
    const handleReturnSuccess = (materialNumber: string, returnData: any, responseEtag?: string) => {
        const item = invoiceData?.data?.itemDetails.find((i: any) => i.materialNumber === materialNumber);
        const returnNetValue = item ? (item.netPrice * returnData.returnQty) : 0;

        setReturnRequests((prev: any) => ({
            ...prev,
            [materialNumber]: {
                ...returnData,
                returnNetValue: returnNetValue,
                status: 'requested'
            }
        }));

        if (responseEtag) {
            setEtag(responseEtag);
        }

        setShowReturnRequestPopup(false);
        setSelectedRow(null);
        setSelectedReturnItem(null);
    };

    const getTotalReturnValue = () => {
        if (returnOrderData?.totalReturnValue && returnOrderData.totalReturnValue > 0) {
            return returnOrderData.totalReturnValue;
        }

        if (invoiceData?.data?.totalReturnValue && invoiceData.data.totalReturnValue > 0) {
            return invoiceData.data.totalReturnValue;
        }

        return Object.values(returnRequests).reduce((sum: number, request: any) => {
            return sum + (request.returnNetValue || 0);
        }, 0);
    };

    const returnOrderNo = returnOrderData?.returnOrderNo || null;

    const getReturnHistoryForItem = (materialNumber: string) => {
        return invoiceData?.data?.returnHistoryList?.find(
            (history: any) => history.materialNumber === materialNumber
        );
    };

    return (
        <div className={classes.root}>
            {loading && <FullscreenLoader />}
            {billingDetails && billingDetails.loading && <FullscreenLoader />}

            <Snackbar
                open={openSnackbar}
                message={successMessage}
                handleopenClose={() => {
                    handleopenCloseSnackbar(false)
                }} />
            <Snackbar
                open={openErrorSnackbar}
                type="error"
                message={showErrorMessage}
                handleopenClose={() => {
                    handleopenCloseErrorSnackbar(false)
                }} />
            <div className="d-flex align-items-center mt-2 mb-4">
                <div>
                    <h2 className="page-title" style={{ marginBottom: 4 }}>View Return Order</h2>
                    <p className="px-1" style={{
                        fontSize: '0.875rem',
                        fontFamily: 'Nunito',
                        color: '#140c0cff',
                        fontWeight: 600,
                        margin: 0
                    }}>
                       Order No: {returnOrderNo || '-'}
                    </p>
                </div>
                <div className="ml-auto">
                    <AnnouncementIcon />
                    <NotificationIcon />
                </div>
            </div>
            <div className={classes.invoiceHeader}>
                <div className={classes.invoiceInfo}>
                    <p className={classes.invoiceId}>Invoice No: {returnOrderData?.invoiceNumber || '-'}</p>
                    <p className={classes.invoiceDate}>
                        Date:{' '}
                        {InoviceDate
                            ? moment(InoviceDate)
                                .tz('Asia/Dubai')
                                .format('DD MMM YYYY')
                            : '-'}
                    </p>
                </div>
                <div className={classes.headerActions}>
                    <IconButton onClick={() => { history.push(`/returnorder`) }} className={`ml-auto ${classes.actionButton}`}>
                        <ChevronLeftIcon fontSize="small" />
                        <span className="backLinkLabel px-2">Back</span>
                    </IconButton>
                    <Button
                        className={classes.exportButton}
                        startIcon={<GetAppIcon />}
                        onClick={() => exportInvoice()}
                        disabled={
                            (!returnOrderData || !returnOrderData.data || returnOrderData.data.length === 0) &&
                            (!invoiceData || !invoiceData.data?.itemDetails || invoiceData.data.itemDetails.length === 0)
                        }
                    >
                        Export to Excel
                    </Button>
                </div>
            </div>
            {/* Table */}
            <div className={classes.tableContainer}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead className={classes.tableHeader}>
                            <TableRow>
                                <TableCell className={`${classes.headerCell}`} style={{ width: 100 }}>
                                    <div className='pb-2'> SN.</div>
                                </TableCell>
                                <TableCell className={`${classes.headerCell}`} style={{ width: 100 }}>
                                    <div className='pb-2'> Part No.</div>
                                    <div className={classes.subHeaderText}></div>
                                </TableCell>
                                <TableCell className={classes.headerCell} style={{ width: 180 }}>
                                    <div className='pb-2'> Description </div>
                                    <div className={classes.subHeaderText}></div>
                                </TableCell>
                                <TableCell className={classes.headerCell} style={{ width: 120 }}>
                                    <div className='pb-2'> Delivered Qty </div>
                                    <div className={classes.subHeaderText}></div>
                                </TableCell>
                                <TableCell className={classes.headerCell} style={{ width: 120 }}>
                                    <div className='pb-2'> Returned Qty </div>
                                    <div className={classes.subHeaderText}></div>
                                </TableCell>
                                <TableCell className={classes.headerCell} style={{ width: 120 }}>
                                    <div className='pb-2'> Return Reason </div>
                                    <div className={classes.subHeaderText}></div>
                                </TableCell>
                                <TableCell className={classes.headerCell} style={{ width: 100 }}>
                                    <div>Unit Price</div>
                                    <div className={classes.subHeaderText}>(Excl. VAT)</div>
                                </TableCell>
                                <TableCell className={classes.headerCell} style={{ width: 100 }}>
                                    <div>Net Value</div>
                                    <div className={classes.subHeaderText}>(Excl. VAT)</div>
                                </TableCell>
                                <TableCell className={classes.headerCell1} style={{ width: 160 }}>
                                    <div>Return Qty</div>
                                    <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: 4, gap: 8 }}>
                                        <div className={classes.subHeaderText1}>Requested</div>
                                        <div className={classes.subHeaderText1}>Approved</div>
                                    </div>
                                </TableCell>
                                <TableCell className={classes.headerCell1} style={{ width: 120 }}>
                                    <div>Return Net Value</div>
                                    <div className={classes.subHeaderText}>(Excl. VAT)</div>
                                </TableCell>
                                <TableCell className={classes.headerCell} style={{ width: 100 }}>
                                    <div className='pb-2'> Status </div>
                                    <div className={classes.subHeaderText}></div>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(() => {
                                const dataSource = returnOrderData?.data || invoiceData?.data?.itemDetails;

                                if (dataSource && dataSource.length > 0) {
                                    return dataSource
                                        .map((item: any, index: number) => {
                                            // Check if return request exists in local state
                                            const returnData = returnRequests[item.materialNumber];
                                            const hasReturnFromAPI = item.returnNetValue && item.returnNetValue > 0;
                                            const isReturnRequested = !!returnData || hasReturnFromAPI;

                                            // Get the display values - prioritize API data over local state
                                            const displayReturnQty = item.returnQty || returnData?.returnQty || '-';
                                            const displayApprovedQty = item.approvedQty || '-';
                                            const displayReturnNetValue = item.returnNetValue || returnData?.returnNetValue || null;
                                            const displayStatus = item.status === "Rejected" ? "Not Approved" : item.status || "-";

                                            return (
                                                <TableRow
                                                    key={index}
                                                    className={isReturnRequested ? classes.returnRequestedRow : ''}
                                                >
                                                    <TableCell className={classes.bodyCell}>{index + 1}</TableCell>
                                                    <TableCell className={classes.bodyCell}>{item.materialNumber || '-'}</TableCell>
                                                    <TableCell className={classes.bodyCell}>{item.description || '-'}</TableCell>
                                                    <TableCell className={classes.bodyCell} align="center">
                                                        {item.deliveredQty || 0}
                                                    </TableCell>
                                                    <TableCell className={classes.bodyCell} align="center">
                                                        {item.returnedQty || '-'}
                                                    </TableCell>
                                                    <TableCell
                                                        className={classes.bodyCell}
                                                        align="center"
                                                        style={{
                                                            width: 200,
                                                            maxWidth: 200,
                                                            whiteSpace: 'normal',
                                                            wordBreak: 'break-word',
                                                        }}
                                                        title={item.reason || '-'}
                                                    >
                                                        {item.reason || '-'}
                                                    </TableCell>
                                                    <TableCell className={classes.bodyCell} align="right">
                                                        {item.netPrice ? item.netPrice.toFixed(2) : '-'}
                                                    </TableCell>
                                                    <TableCell className={classes.bodyCell} align="right">
                                                        {item.netValue ? item.netValue.toFixed(2) : '-'}
                                                    </TableCell>
                                                    <TableCell className={classes.bodyCell1} align="center">
                                                        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                                            <div>{displayReturnQty}</div>
                                                            <div>
                                                                {returnOrderData?.headerStatus === "Quality check pending" ? '-' : displayApprovedQty}
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.bodyCell1} align="center">
                                                        {displayReturnNetValue ? displayReturnNetValue.toFixed(2) : '-'}
                                                    </TableCell>
                                                    <TableCell className={classes.bodyCell2} style={{ color: getStatusColor(displayStatus) }} align="center">
                                                        {returnOrderData?.headerStatus !== "Quality check pending" && displayStatus}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        });
                                } else {
                                    return (
                                        <TableRow>
                                            <TableCell colSpan={10} align="center" className={classes.bodyCell}>
                                                Invoice details are unavailable.
                                            </TableCell>
                                        </TableRow>
                                    );
                                }
                            })()}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* Pagination */}
                <div className={`${classes.paginationContainer} mt-5`}>

                    <div className={`${classes.buttonSection} pl-2 py-3`}>
                        <div className={classes.actionButtons1} >
                            <p className={`${classes.grossValue} pt-2 px-4 pr-4`} >
                                Estimated Total Return Value (Excl. of VAT) : AED {getTotalReturnValue().toFixed(2)}
                            </p>
                        </div>

                    </div>
                </div>

                {showReturnRequestPopup && (
                    <ReturnRequestPopup
                        open={showReturnRequestPopup}
                        handleopenClose={() => {
                            setShowReturnRequestPopup(false);
                            setSelectedRow(null);
                            setSelectedReturnItem(null);
                        }}
                        selectedItem={selectedReturnItem}
                        invoiceData={invoiceData}
                        existingReturnData={(() => {
                            // If existingReturnData is already set in selectedReturnItem, use it
                            if (selectedReturnItem?.existingReturnData) {
                                return selectedReturnItem.existingReturnData;
                            }

                            // If item has returnNetValue from API, fetch data from returnHistoryList
                            if (selectedReturnItem && selectedReturnItem.returnNetValue && selectedReturnItem.returnNetValue > 0) {
                                const returnHistory = getReturnHistoryForItem(selectedReturnItem.materialNumber);
                                return {
                                    returnQty: selectedReturnItem.returnQty,
                                    returnReason: returnHistory?.reason || '',
                                    returnImages: returnHistory?.returnImages || {},
                                    returnNetValue: selectedReturnItem.returnNetValue
                                };
                            }

                            // Otherwise use local state
                            return returnRequests[selectedReturnItem?.materialNumber] || null;
                        })()}
                        isUpdateMode={
                            (selectedReturnItem?.returnNetValue && selectedReturnItem.returnNetValue > 0) ||
                            (selectedReturnItem && !!returnRequests[selectedReturnItem.materialNumber])
                        }
                        onReturnSuccess={handleReturnSuccess}
                        currentEtag={etag}
                    />
                )}

                {showAllReturnRequestPopup && (
                    <ReturnAllRequestPopup
                        open={showAllReturnRequestPopup}
                        handleopenClose={() => {
                            setShowAllReturnRequestPopup(false);
                            setSelectedRow(null);
                            setSelectedReturnItem(null);
                        }}
                        selectedItem={selectedReturnItem}
                        invoiceData={invoiceData}
                        existingReturnData={(() => {
                            // If existingReturnData is already set in selectedReturnItem, use it
                            if (selectedReturnItem?.existingReturnData) {
                                return selectedReturnItem.existingReturnData;
                            }

                            // If item has returnNetValue from API, fetch data from returnHistoryList
                            if (selectedReturnItem && selectedReturnItem.returnNetValue && selectedReturnItem.returnNetValue > 0) {
                                const returnHistory = getReturnHistoryForItem(selectedReturnItem.materialNumber);
                                return {
                                    returnQty: selectedReturnItem.returnQty,
                                    returnReason: returnHistory?.reason || '',
                                    returnImages: returnHistory?.returnImages || {},
                                    returnNetValue: selectedReturnItem.returnNetValue
                                };
                            }

                            // Otherwise use local state
                            return returnRequests[selectedReturnItem?.materialNumber] || null;
                        })()}
                        isUpdateMode={
                            (selectedReturnItem?.returnNetValue && selectedReturnItem.returnNetValue > 0) ||
                            (selectedReturnItem && !!returnRequests[selectedReturnItem.materialNumber])
                        }
                        onReturnSuccess={handleReturnSuccess}
                        currentEtag={etag}
                    />
                )}
            </div>
        </div>
    );
}